'use strict';
window._theme = window._theme || {};

_theme.PageArticle = (function () {
  function init() {
    const sliderFunc = function (selector, settings) {
      if (!selector || !settings) return;
      let $productGrid = selector;
      if (typeof selector === 'string') {
        $productGrid = $(selector);
      }
      if (typeof selector === 'object' && !$productGrid.hasOwnProperty('length')) {
        $productGrid = $(selector);
      }
      if ($productGrid.length === 0) return;
      if ($productGrid.hasClass('slick-initialized')) {
        $productGrid.slick('unslick');
      }
      $productGrid.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
        slick.$slider
          .find('.slick-slide[aria-hidden="true"] .product-bottom .selected_option')
          .attr('tabindex', -1);
        slick.$slider
          .find(
            '.slick-slide[aria-hidden="false"] .product-bottom [data-customselect] .selected_option'
          )
          .attr('tabindex', 0);
        setTimeout(function () {
          slick.$slider.find('.slick-slide').removeAttr('tabindex');
        }, 200);
      });
      $productGrid.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
        slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
        slick.$slider
          .find('.slick-slide[aria-hidden="true"] .product-bottom .selected_option')
          .attr('tabindex', -1);
        slick.$slider
          .find(
            '.slick-slide[aria-hidden="false"] .product-bottom [data-customselect] .selected_option'
          )
          .attr('tabindex', 0);
        setTimeout(function () {
          slick.$slider.find('.slick-slide').removeAttr('tabindex');
        }, 200);
      });
      $productGrid.on('init', function (event, slick, currentSlide, nextSlide) {
        slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
        slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
        slick.$slider
          .find('.slick-slide[aria-hidden="true"] .product-bottom .selected_option')
          .attr('tabindex', -1);
        slick.$slider
          .find(
            '.slick-slide[aria-hidden="false"] .product-bottom [data-customselect] .selected_option'
          )
          .attr('tabindex', 0);
        setTimeout(function () {
          slick.$slider.find('.slick-slide').removeAttr('tabindex');
        }, 200);
      });

      $productGrid.slick(settings);
    };

    if (!$('.releted-blogs .blog-slider').children().length) {
      $('.releted-blogs').hide();
    }
    if ($('.blog-slider').length > 0) {
      $('.blog-slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
              arrows: false,
              infinite: true,
            },
          },
        ],
      });
    }

    if ($('.article-product-collection').length) {
      $('.article-product-collection').slick({
        rows: 0,
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 6,
        accessibility: true,
        slidesToScroll: 3,
        mobileFirst: true,
        responsive: [
          { breakpoint: 1500, settings: { slidesToShow: 6 } },
          { breakpoint: 1300, settings: { slidesToShow: 5 } },
          { breakpoint: 991, settings: { slidesToShow: 4 } },
          { breakpoint: 600, settings: { slidesToShow: 3 } },
          { breakpoint: 320, settings: { slidesToShow: 1.5, slidesToScroll: 1 } },
          { breakpoint: 1, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      });
    }

    sliderFunc($('.articles_slider'), {
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    });

    sliderFunc($('[data-template="article.art-1"] .articles_idea_slider'), {
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1.5,
          },
        },
        {
          breakpoint: 601,
          settings: {
            slidesToShow: 2.5,
          },
        },
        {
          breakpoint: 901,
          settings: {
            slidesToShow: 3.5,
          },
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 5,
          },
        },
      ],
    });

    sliderFunc($('[data-template="article.template-4"] .articles_idea_slider'), {
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1.5,
          },
        },
        {
          breakpoint: 601,
          settings: {
            slidesToShow: 1.5,
          },
        },
        {
          breakpoint: 901,
          settings: {
            slidesToShow: 2.5,
          },
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
  }

  return { init: init };
})();

$(function () {
  _theme.PageArticle.init();
});

$(document).ready(function () {
  $('[data-selectedoption]').on('click', function (event) {
    event.stopPropagation();

    const currentTarget = $(this);
    const optionList = currentTarget.parents('.product_details').find('[data-optionList]');
    const customSelect = currentTarget.parents('.product_details').find('[data-customselect]');
    const isActive = currentTarget.hasClass('active');

    $('[data-customselect] [data-optionList]').removeClass('active');
    // $('[data-customselect]').attr('aria-expanded', 'false');

    currentTarget.toggleClass('active', !isActive);
    optionList.toggleClass('active', !isActive);
    customSelect.toggleClass('active', !isActive);
    currentTarget.attr('aria-expanded', !isActive);
    optionList.find('li').focus();
    _theme.focusTrap(
      optionList,
      function () {
        currentTarget.removeClass('active').attr('aria-expanded', false);
        currentTarget[0].focus();
      },
      'li[tabindex="0"]'
    );
  });

  $('[data-optionList] li').on('click', function (event) {
    event.stopPropagation();
    const currentTarget = $(this);

    const varID = currentTarget.attr('data-vId');
    const price = parseInt(currentTarget.attr('data-price'));
    const cprice = parseInt(currentTarget.attr('data-cprice'));

    const optionText = currentTarget.find('.option_value').text();
    const optionImage = currentTarget.find('.option_image').attr('src');

    const customSelectContainer = currentTarget.closest('[data-customSelectContainer]');
    const customSelect = customSelectContainer.find('[data-customselect]');
    const productPrice = customSelectContainer.find('[data-productPrice]');

    const customATC = customSelectContainer.find('[data-customATC]');
    customATC.attr('data-pId', varID);

    customSelect.find('[data-selectedoption] .option_value').text(optionText);
    customSelect.find('[data-selectedoption] .option_image').attr('src', optionImage);
    customSelect.find('.option_name').html(`<strong>Size: </strong> ${optionText}`);

    productPrice
      .find('[data-currentPrice]')
      .html(
        `<span class="visually-hidden">Discounted Price </span>${Shopify.formatMoney(price, Shopify.money_format)}`
      );
    if (cprice && cprice > price) {
      productPrice
        .find('[data-originalPrice]')
        .html(
          `<span class="visually-hidden">Regular Price </span>${Shopify.formatMoney(cprice, Shopify.money_format)}`
        );
      productPrice
        .find('[data-discountPrice]')
        .html(`Save ${Shopify.formatMoney(cprice - price, Shopify.money_format)}`);
    } else {
      productPrice.find('[data-originalPrice]').text('');
      productPrice.find('[data-discountPrice]').text('');
    }

    customSelect.find('[data-optionList]').removeClass('active');
    customSelect.attr('aria-expanded', 'false');

    customSelect.focus();
  });

  $('[data-customATC]').on('click', function (event) {
    event.preventDefault();

    const id = $(this).attr('data-pId');
    if (!id) return;

    _theme.toggleLoading(1);
    const customAddedMessage = $(this).siblings('[data-customAddedMessage]');
    customAddedMessage.text('Please wait, adding product to the cart');

    _theme.Helpers.addProductToCart(
      id,
      1,
      null,
      function (response) {
        _theme.MiniCart.lineItemChangeCallBack(response, function () {
          customAddedMessage.text('Item added to your cart successfully');
          _theme.toggleLoading();
          _theme.toggleSideCart(1);
        });
      },
      function (error) {
        console.error(error);
      }
    );
  });
  $(document)
    .off('keydown', '[data-customselect] li')
    .on('keydown', '[data-customselect] li', _theme.handleKeyboardUpDownButtonPress);
  $('[data-selectedoption]').on('keydown', function (event) {
    const currentTarget = $(this);
    const optionList = currentTarget.parents('.product_details').find('[data-optionList]');
    const customSelect = currentTarget.parents('.product_details').find('[data-optionList]');

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      currentTarget.click();
    } else if (event.key === 'Escape') {
      optionList.removeClass('active');
      customSelect.removeClass('active');
      currentTarget.attr('aria-expanded', 'false');
    }
  });

  $(document).on('click', function (event) {
    $('[data-customselect] [data-optionList]').removeClass('active');
    $('[data-customselect]').attr('aria-expanded', 'false');
  });
  const allAnchorTitle = document.querySelectorAll("body[data-template='article.art-1'] main a");
  allAnchorTitle.forEach((el) => {
    const titleAttr = el.getAttribute('title');
    const hrefText = el.getAttribute('href');
    const splitText = hrefText.split('/');
    const lastText = splitText[splitText.length - 1].replaceAll('-', ' ');
    const anchorInnerText = el.innerText;
    if (titleAttr) {
      el.setAttribute('aria-label', `${anchorInnerText} Redirects to ${lastText}`);
      el.removeAttribute('title');
    }
  });
});
